/**************************************************
 * Nombre:       Tarjetas_Producto_Look
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Box, Button, Grid, Typography} from "@mui/material";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {useNavigate} from "react-router";
import {useEffect, useState} from "react";
import {useHookBotonCantidadDrawer} from "../Hooks/useHookBotonCantidadDrawer";
import {useFuncionesCarritoLateral} from "../../Modulo_Carrito_Lateral/Hooks/useFuncionesCarritoLateral";
import {adap_producto_carrito_lateral} from "../../Modulo_Carrito_Lateral/Adaptadores/adap_producto_carrito_lateral";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjetas_Producto_Look = ({item, cerrar}) => {
    const {sCell} = useResponsive()
    const navigate = useNavigate()
    const [varianteEscogida, setVarianteEscogida] = useState({})
    const [variaciones, setVariaciones] = useState([])
    const {Boton, cantidad} = useHookBotonCantidadDrawer({variante: varianteEscogida})
    const {adicionarProducto} = useFuncionesCarritoLateral()
    const [cargando, setCargando] = useState(false)

    const agregar = () => {

        setCargando(true)
        let prod = adap_producto_carrito_lateral({
            producto: item,
            cantidad: cantidad,
            variacion: varianteEscogida
        })

        adicionarProducto(prod)

        setTimeout(() => {
            setCargando(false)
        }, 2500)

    }

    function ordenarPorNombre(array) {
        return [...array].sort((a, b) => {
            return a.nombre.localeCompare(b.nombre, 'es', {sensitivity: 'base'});
        });
    }

    useEffect(() => {


        if (item.variaciones) {
            let varias = ordenarPorNombre(item.variaciones);
            varias.reverse()
            setVarianteEscogida(varias[0]);
            setVariaciones(varias);
        }


    }, [item]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, borderColor: '#00000030', pr: sCell ? 0 : 2, py: 2}}
            spacing={1}
        >

            <Grid container  size={{xs: 3, sm: 3, md: 3}}>
                <img onClick={() => navigate('/Detalle/' + item.id)} src={item.img} width={'90%'}
                     style={{cursor: 'pointer'}}/>
            </Grid>

            <Grid container  size={{xs: 6, sm: 6, md: 7}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                spacing={0}
                >


                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography
                            onClick={() => navigate('/Detalle/' + item.id)}
                            sx={{
                                fontWeight: 600,
                                lineHeight: 1.1,
                                fontSize: sCell ? 14 : 16,
                                cursor: 'pointer'
                            }}>{`${item.nombre}`}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: 12
                            }}>{formatoMoneda(item.valor)}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{fontSize: 12}}>Talla / Tipo:</Typography>
                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 9}}
                        spacing={sCell ? 1 : 2}
                        sx={{mt: 1}}
                    >

                        {variaciones.map((item, index) => (
                            <Box
                                onClick={() => setVarianteEscogida(item)}
                                sx={{
                                    border: 1,
                                    borderColor: '#000',
                                    px: 2, pt: 0.2, pb: 0.1,
                                    backgroundColor: varianteEscogida.nombre === item.nombre ? '#000' : 'white',
                                    color: varianteEscogida.nombre === item.nombre ? '#fff' : '#000',
                                    cursor: 'pointer',
                                }}>
                                <Typography sx={{fontSize: 12}}>{item.nombre}</Typography>
                            </Box>
                        ))}

                    </Grid>


                </Grid>


            </Grid>


            <Grid
                container
                justifyContent={'flex-end'}
                alignItems={'flex-start'}
                size={{xs: 3, sm: 2, md: 2}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                    <Boton/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: 1}}>
                    <Button
                        loading={cargando}
                        disabled={cantidad === 0}
                        onClick={() => agregar()}
                        sx={{fontSize: 10}}>Agregar</Button>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Tarjetas_Producto_Look